import React, { useEffect, useState } from 'react'
import classnames from "classnames";
import Styles from "./styles.module.scss";
import { Icon } from "@iconify/react";
import * as CONSTANTS from '../../utils/CONSTANTS'
import DropDownListselect from '../../components/dropdown';
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';

interface props  {
  applyDurationFilter?: any;  
}

const ReportsDurationFilter: React.FC<props> =  ({
  applyDurationFilter
}) => {

    // "duration": data.dateWithin && { "from": data.dateWithin.from, "to": data.dateWithin.to },
    const [isActive, setActive] = useState<boolean>(true)
    const [appliedFilter, setAppliedFilter] = useState<any>()
    const [month, setMonth] = useState<any>()
    const [year, setYear] = useState<string>('')
    const [date, setDate] = useState<{ month: any, year: string }>()
    
    const ToggleClass = () => {
      setActive(!isActive); 
     
     };

  let presentMonthNumber = new Date().getMonth();
  const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  let presentMonth = months[presentMonthNumber]
  let presentYear = new Date().getFullYear()

  
    useEffect(() => {    
        if (date) {
          applyDurationFilter(date) 
          setAppliedFilter(`${date.month && date.month.name}, ${date.year}`)
      }
        else {
          setAppliedFilter(`${presentMonth}, ${presentYear}`)
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [date])
    
    
    const handleChange = (value: any, name: string) => {
     
        if (name === 'month') {
            setMonth(value)
            setDate({month: value, year: year})
        }
        if (name === 'year') {
            setYear(value)
            setDate({month: month, year: value})

        }
    }

    return (
      
        <div className={Styles.notiWithSort}>
           <div className={Styles.sortButton}>
                <button className={!appliedFilter ? Styles.button : Styles.buttonAct} onClick={ToggleClass}><Icon icon="fa6-regular:clock" />{appliedFilter ? appliedFilter : 'Filter'}<Icon icon="charm:chevron-down" /></button>
          <div className={isActive ? Styles.sortDropdown : Styles.sortDropdownAct}>
                    <div className={classnames("breakDateInput", Styles.sortDate)}>
                        <label>Month</label>
                        <DropDownListselect
                            data={CONSTANTS.monthsWithId}
                            onChange={(e: DropDownListChangeEvent) => handleChange(e.value, 'month')}
                            dataItemKey='id'
                            textField='name'/>
                        <label>Year</label>
                        <DropDownListselect
                            data={CONSTANTS.years}
                            onChange={(e: DropDownListChangeEvent) => handleChange(e.value, 'year')} />
   
            </div>
            {/* <div className={Styles.sortItems}>
              <button onClick={() => handleChange(2,'Last 1 Month')} className={activeButton === 2 ? classnames(Styles.active,Styles.sortBtn) : Styles.sortBtn}>Last 1 Month</button>
              <button onClick={() => handleChange(3,'Last 3 Months')} className={activeButton === 3 ? classnames(Styles.active,Styles.sortBtn) : Styles.sortBtn}>Last 3 Month</button>
              <button onClick={() => handleChange(4,'Last 6 Months')} className={activeButton === 4 ? classnames(Styles.active,Styles.sortBtn) : Styles.sortBtn}>Last 6 Month</button>
              <button onClick={() => handleChange(5,'Last 1 Year')} className={activeButton === 5 ? classnames(Styles.active,Styles.sortBtn) : Styles.sortBtn}>Last 1 Year</button>
            </div> */}
            
          </div>
        </div>


    </div>
  )
}

export default ReportsDurationFilter